import { useState, useEffect } from "react";
export interface GoogleUser {
  id: number;
  googleId: string;
  name: string | null;
  email: string | null;
  role: "user" | "admin" | "lider" | "operador" | "cliente";
  emitenteId?: number | null;
  variacaoMaxVenda?: number | null;
}
export function useGoogleAuth() {
  const [user, setUser] = useState<GoogleUser | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    checkAuth();

    // Re-verificar autenticação quando o usuário volta à aba após longo período
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkAuth();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  const checkAuth = async () => {
    try {
      const response = await fetch("/auth/me", {
        credentials: "include",
      });
      if (response.ok) {
        const data = await response.json();
        setUser(data.user);
        console.log("[useGoogleAuth] data.user:", data.user);
        console.log("[useGoogleAuth] data.user.role:", data.user?.role);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("Auth check failed:", error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };
  const logout = async () => {
    try {
      await fetch("/auth/logout", {
      method: "POST",
        credentials: "include",
      });
      setUser(null);
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  return {
    user,
    loading,
    isAuthenticated: !!user,
    logout,
    checkAuth,
  };
}
